import { render } from "./AdminUpdateBooking.vue?vue&type=template&id=922a55e4&ts=true&lang=pug"
import script from "./AdminUpdateBooking.vue?vue&type=script&setup=true&lang=ts"
export * from "./AdminUpdateBooking.vue?vue&type=script&setup=true&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__